import { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LogOut, LayoutDashboard, Inbox, Trophy } from "lucide-react";

export default function AdminLayout() {
  const { user, loading, logout } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    if (!loading && (!user || !user.is_admin)) {
      nav("/admin/login", { replace: true });
    }
  }, [loading, user, nav]);

  if (loading || !user) {
    return <div data-testid="admin-loading" className="container-x py-32 text-[#4A4D50]">Loading…</div>;
  }

  const linkCls = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-3 text-sm font-medium border-l-2 transition-colors ${
      isActive ? "border-[#0F172A] bg-[#0F172A]/5 text-[#0F172A]" : "border-transparent text-[#4A4D50] hover:text-[#0F172A]"
    }`;

  return (
    <div data-testid="admin-layout" className="min-h-screen grid grid-cols-1 md:grid-cols-[260px_1fr]">
      <aside className="border-r border-[#0F172A]/10 bg-[#F7F5F0] p-6 md:min-h-screen">
        <div className="font-display text-xl text-[#0F172A]">EB·Immigration</div>
        <div className="text-xs eyebrow text-[#C2A679] mt-1">Attorney Portal</div>
        <nav className="mt-10 flex flex-col gap-1">
          <NavLink to="/admin" end className={linkCls} data-testid="nav-dashboard">
            <LayoutDashboard size={16} /> Dashboard
          </NavLink>
          <NavLink to="/admin/submissions" className={linkCls} data-testid="nav-submissions">
            <Inbox size={16} /> Case Reviews
          </NavLink>
          <NavLink to="/admin/success-stories" className={linkCls} data-testid="nav-stories">
            <Trophy size={16} /> Success Stories
          </NavLink>
        </nav>
        <div className="mt-16 pt-6 border-t border-[#0F172A]/10">
          <div className="text-sm text-[#0F172A] font-medium">{user.name || user.email}</div>
          <div className="text-xs text-[#4A4D50] font-mono-plex truncate">{user.email}</div>
          <button
            data-testid="logout-btn"
            onClick={async () => { await logout(); nav("/admin/login"); }}
            className="mt-4 flex items-center gap-2 text-xs text-[#4A4D50] hover:text-[#0F172A] transition-colors"
          >
            <LogOut size={14} /> Sign out
          </button>
        </div>
      </aside>
      <main className="p-8 md:p-12">
        <Outlet />
      </main>
    </div>
  );
}
